<template>
  <svg
    v-if="icon === 'interface-employee-card'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M14.1667 2H1.83333C0.822 2 0 2.822 0 3.83333V12.1667C0 13.178 0.822 14 1.83333 14H14.1667C15.178 14 16 13.178 16 12.1667V3.83333C16 2.822 15.178 2 14.1667 2ZM5 4.66667C5.91867 4.66667 6.66667 5.41467 6.66667 6.33333C6.66667 7.252 5.91867 8 5 8C4.08133 8 3.33333 7.252 3.33333 6.33333C3.33333 5.41467 4.08133 4.66667 5 4.66667ZM8 10.8333C8 11.1093 7.776 11.3333 7.5 11.3333H2.5C2.224 11.3333 2 11.1093 2 10.8333V10.5C2 9.48867 2.822 8.66667 3.83333 8.66667H6.16667C7.178 8.66667 8 9.48867 8 10.5V10.8333ZM13.5 11.3333H9.83333C9.55733 11.3333 9.33333 11.1093 9.33333 10.8333C9.33333 10.5573 9.55733 10.3333 9.83333 10.3333H13.5C13.776 10.3333 14 10.5573 14 10.8333C14 11.1093 13.776 11.3333 13.5 11.3333ZM13.5 8.66667H9.83333C9.55733 8.66667 9.33333 8.44267 9.33333 8.16667C9.33333 7.89067 9.55733 7.66667 9.83333 7.66667H13.5C13.776 7.66667 14 7.89067 14 8.16667C14 8.44267 13.776 8.66667 13.5 8.66667ZM13.5 6H9.83333C9.55733 6 9.33333 5.776 9.33333 5.5C9.33333 5.224 9.55733 5 9.83333 5H13.5C13.776 5 14 5.224 14 5.5C14 5.776 13.776 6 13.5 6Z"
        fill="#52525F"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'interface-employee-appoint'"
    width="8"
    height="15"
    viewBox="0 0 8 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.87501 12.9375C7.87501 12.1377 7.4171 11.4433 6.75001 11.1013V12.1875C6.75001 13.118 5.99296 13.875 5.06251 13.875H2.8125C1.88201 13.875 1.125 13.118 1.125 12.1875V11.1013C0.457913 11.4433 0 12.1377 0 12.9375C0 14.0748 0.925238 15 2.0625 15H5.81251C6.94977 15 7.87501 14.0748 7.87501 12.9375Z"
      fill="#52525F"
    />
    <path
      d="M5.625 1.6875C5.625 0.757013 4.86803 0 3.9375 0C3.00698 0 2.25 0.757013 2.25 1.6875C2.25 2.61799 3.00698 3.375 3.9375 3.375C4.86803 3.375 5.625 2.61799 5.625 1.6875Z"
      fill="#52525F"
    />
    <path
      d="M1.125 7.3125V9.1875C1.125 9.49815 1.37685 9.75 1.6875 9.75H2.25V10.875V12.1875C2.25 12.4982 2.50185 12.75 2.8125 12.75H5.0625C5.37315 12.75 5.625 12.4982 5.625 12.1875V10.875V9.75H6.18751C6.49816 9.75 6.75001 9.49815 6.75001 9.1875V7.3125C6.75001 5.76169 5.48832 4.5 3.9375 4.5C2.38669 4.5 1.125 5.76169 1.125 7.3125Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-employee-invite'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 9L8 11L5.5 9C5.66667 8.33333 6.4 7 8 7C9.6 7 10.3333 8.33333 10.5 9Z"
      fill="#52525F"
    />
    <path d="M16 6L9.5 11L16 15V6Z" fill="#52525F" />
    <path d="M0 6L6.5 11L0 15V6Z" fill="#52525F" />
    <path d="M15.5 16H0.5L7 11.5L8 12.5L9 11.5L15.5 16Z" fill="#52525F" />
    <path d="M1.5 6V4.5L0.5 5.5L1.5 6Z" fill="#52525F" />
    <path d="M14 6V4.5L15 5.5L14 6Z" fill="#52525F" />
    <path
      d="M2.5 7L4.5 8.5C4.1 7.7 5.66667 6.5 6.5 6C6 5.5 5.5 3 8 3C10.5 3 10 5.33333 9.5 6C11.5 6.8 11.6667 8 11.5 8.5L13.5 7V0H2.5V7Z"
      fill="#52525F"
    />
    <circle cx="8" cy="5" r="1" fill="#52525F" />
  </svg>
  <svg
    v-else-if="icon === 'interface-employee-add'"
    width="19"
    height="16"
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M5.15155 6.78376C5.29731 7.73122 6.02944 8.93709 7.23199 9.36112C7.7256 9.53339 8.26559 9.5367 8.7592 9.35781C9.94187 8.93046 10.6972 7.72791 10.8463 6.78376C11.0053 6.77051 11.214 6.54855 11.4393 5.75016C11.7473 4.66025 11.4194 4.49792 11.1411 4.52443C11.1941 4.37535 11.2339 4.22296 11.2604 4.0772C11.7308 1.25137 10.3394 1.1553 10.3394 1.1553C10.3394 1.1553 10.1075 0.711384 9.50126 0.37679C9.09379 0.134955 8.5273 -0.0505617 7.78192 0.0123816C7.54008 0.02232 7.3115 0.0720121 7.09617 0.141581C6.8212 0.23434 6.56943 0.370165 6.34085 0.52918C6.06257 0.704758 5.79755 0.923404 5.56565 1.17186C5.19793 1.54952 4.86996 2.03651 4.72751 2.64275C4.60825 3.09661 4.63475 3.57034 4.73413 4.08051C4.76064 4.22959 4.80039 4.37866 4.85339 4.52774C4.57512 4.50124 4.24715 4.66356 4.55524 5.75348C4.78383 6.54855 4.99253 6.77051 5.15155 6.78376Z"
        fill="#52525F"
      />
      <path
        d="M13.4634 10.4908C11.7705 10.0601 10.3957 9.09277 10.3957 9.09277L9.32237 12.4884L9.12029 13.1278L9.11698 13.1178L8.9414 13.6611L8.37491 12.0544C9.76629 10.1131 8.09332 10.133 8.00056 10.1363C7.9078 10.133 6.23484 10.1131 7.62622 12.0544L7.05973 13.6611L6.88415 13.1178L6.88083 13.1278L6.67875 12.4884L5.60209 9.09277C5.60209 9.09277 4.22728 10.0601 2.53443 10.4908C1.27225 10.8121 1.21262 12.2698 1.26231 12.9886C1.26231 12.9886 1.33519 13.9659 1.40808 14.3966C1.40808 14.3966 3.8728 15.9967 8.00056 16C12.1283 16 14.593 14.3966 14.593 14.3966C14.6659 13.9659 14.7388 12.9886 14.7388 12.9886C14.7852 12.2698 14.7256 10.8121 13.4634 10.4908Z"
        fill="#52525F"
      />
    </g>
    <path
      d="M16 1.375C14.5504 1.375 13.375 2.55039 13.375 4C13.375 5.44961 14.5504 6.625 16 6.625C17.4496 6.625 18.625 5.44961 18.625 4C18.625 2.55039 17.4496 1.375 16 1.375ZM17.125 4.14062C17.125 4.16641 17.1039 4.1875 17.0781 4.1875H16.1875V5.07812C16.1875 5.10391 16.1664 5.125 16.1406 5.125H15.8594C15.8336 5.125 15.8125 5.10391 15.8125 5.07812V4.1875H14.9219C14.8961 4.1875 14.875 4.16641 14.875 4.14062V3.85938C14.875 3.83359 14.8961 3.8125 14.9219 3.8125H15.8125V2.92188C15.8125 2.89609 15.8336 2.875 15.8594 2.875H16.1406C16.1664 2.875 16.1875 2.89609 16.1875 2.92188V3.8125H17.0781C17.1039 3.8125 17.125 3.83359 17.125 3.85938V4.14062Z"
      fill="#52525F"
    />
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'IconsInterfaceProjects',
  props: {
    icon: String,
  },
}
</script>

<style scoped></style>
